module.exports = __webpack_public_path__ + "img/aboutUs-building.db8575b1.png";